import parse from 'date-fns/parse';
import isValid from 'date-fns/is_valid';
import dateFnFormat from 'date-fns/format';

const formatString = 'D MMM, YYYY';

export const format = (startDateString, endDateString) => {
	const startDate = parse(startDateString);
	const endDate = parse(endDateString);

	let formatted = isValid(startDate) ? dateFnFormat(startDate, formatString) : '';

	if (formatted && isValid(endDate)) {
		formatted += ` - ${dateFnFormat(endDate, formatString)}`;
	}

	return formatted;
};



// WEBPACK FOOTER //
// ./src/managers/dateManager.js